<template>
  <div>
    <section class="section is-main-section">
      <card-component title="Role Form" icon="account" has-back>
        <form @submit.prevent="submit">
          <b-field label="Role" horizontal>
            <b-input placeholder="Roleame" v-model="form.name" />
          </b-field>
          <hr />
          <b-field horizontal>
            <p>GET</p>
            <p>POST</p>
            <p>PUT</p>
            <p>DELETE</p>
          </b-field>
          <b-field
            v-for="key in Object.keys(permissions)"
            :key="key"
            :label="key"
            horizontal
          >
            <b-checkbox
              v-for="method in ['GET', 'POST', 'PUT', 'DELETE']"
              v-model="form.permissions"
              :key="method + key"
              :native-value="permissions[key][method]"
              grouped
              group-multiline
              :class="{ hidden: !permissions[key][method] }"
            />
          </b-field>
          <hr />
          <b-field horizontal>
            <b-button
              type="is-primary"
              :loading="isLoading"
              native-type="submit"
              >Submit</b-button
            >
          </b-field>
        </form>
      </card-component>
    </section>
  </div>
</template>

<script>
import { read as readPermission } from '@/api/permission'
import { create as createRole } from '@/api/role'

export default {
  name: 'CreateRole',
  data() {
    return {
      isLoading: false,
      permissions: {},
      form: {
        name: null,
        permissions: []
      }
    }
  },
  created() {
    readPermission()
      .then(res => {
        res.data.permissions.map(permission => {
          if (!this.permissions[permission.module]) this.$set(this.permissions, permission.module, {})
          this.permissions[permission.module][permission.method] = permission.id
        })
      })
  },
  methods: {
    submit() {
      this.isLoading = true

      createRole(this.form)
        .then(() => {
          this.$router.back()
        })
        .catch(e => {
          this.$buefy.toast.open({
            message: e.response.data,
            type: 'is-danger',
            queue: false
          })
        })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.b-checkbox.hidden {
  opacity: 0;
}
</style>
